import { CPF } from 'cpf_cnpj'
import { CNPJ } from '@utils/cnpj'
import { Checkbox, Form, FormError, Radio, RadioGroup, Text } from 'react-form'
import {
  InputCheckbox,
  InputText,
  SelectState,
  regexEmail,
  regexPassword,
  regexZipcodeFull,
  InputPassword,
} from '@shared/CustomField'
import React, { Component } from 'react'
import NormalizeBrazilianStates from '@shared/NormalizeBrazilianStates'

import { getFreight, resetFreight } from '@actions/freight'

import Cep from 'cep-promise'
import ConfirmDialog from '@shared/ConfirmDialog'
import { Modal } from 'react-bootstrap'
import { CepNotDeliverableModal, FreightUnavailableModal } from '@shared/CepNotDeliverableModal'
import _ from 'lodash'
import { connect } from 'react-redux'
import { closeLoader, openLoader } from '@actions/loader.js'
import { closeModal, openModal } from '@actions/modal.js'
import { listVariables, getIeByCnpj } from '@services/sm-api'
import { withRouter } from '@utils/withRouter'
import moment from 'moment'
import { regexFullName, regexInvalidCharTest, regexInvalidCharName, maxLengthName } from '../../shared/CustomField'

class RegisterForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showingField: null,
      fullAddress: {},
      email: '',
      userAlreadyExists: {},
      address_zipcode: '',
      address_found: false,
      address_incomplete: false,
      delivery_address_zipcode: '',
      delivery_address_found: false,
      delivery_address_incomplete: false,
      // SMME26-26: `ieExempt` (confirmado sem IE) é o ÚNICO gatilho de exibição do checkbox
      // "Isento" — antes a visibilidade era por negação (`!ieFound`), o que fazia o checkbox
      // aparecer antes de qualquer consulta e reaparecer durante a requisição.
      ieExempt: false,
      ieInactive: false,
      ieNotFound: false,
      ieError: false,
      lastCheckedCnpj: '',
      ieModalOpen: false,
      school_is_b2c: false,
      variableTermUse: {},
      variablePrivacyPolicy: {},
      addressModalClose: false,
      unique_zipcode: false,
      invalid_address_zipcode: false,
      disable_address_state: true,
      disable_delivery_address_state: true,
      delivery_invalid_address_zipcode: false,
      same_address: true,
      showModalFreight: false,
      showModalFreightUnavailable: false,
      showConfirmEmailModal: false,
      delivery_unique_zipcode: false,
      dataToRegister: null,
      ieFetching: false,
    }

    this.hideDefaultError = { style: { display: 'none' } }
    this._getAddress = this._getAddress.bind(this)
    this._getDeliveryAddress = this._getDeliveryAddress.bind(this)
    this._validateForm = this._validateForm.bind(this)
  }

  /**
   * Set error on email field if the email already exists
   **/
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (typeof nextProps.user.error !== 'undefined' && this.refs.Form.state.errors) {
      this.refs.Form.state.errors.email = nextProps.user.error
    }

    // SMME26-42: assim que um novo cálculo de frete volta com restrição de CEP,
    // abre o modal na hora (sem esperar o submit).
    if (
      this.state.school_is_b2c &&
      nextProps.has_delivery_restriction &&
      nextProps.freight_redux_requests !== this.props.freight_redux_requests
    ) {
      this.setState({ showModalFreight: true })
    }
  }

  /**
   * Get full address by CEP number and fill the adresses fields
   **/
  _getAddress(event, setValue, setAllValues) {
    this.props.openLoader()
    const value = event.target.value
    let cep = value.replace('-', '')

    if (cep.length === 8) {
      Cep(cep)
        .then(data => {
          this.setState({
            address_found: true,
            address_incomplete: false,
          })
          setValue('address_number', '', true)
          setValue('address_complement', '', true)
          setValue('address_reference', '', true)
          setValue('address_street', data.street, true)
          setValue('address_city', data.city, true)
          setValue('address_neighborhood', data.neighborhood, true)
          if (data.state && NormalizeBrazilianStates(data.state)) {
            setValue('address_state', NormalizeBrazilianStates(data.state), true)
          } else {
            this.setState({ disable_address_state: false })
          }

          if (this.state.same_address) {
            this._getFreight(data)
            setValue('address_zipcode_delivery', value, true)
            setValue('address_number_delivery', '', true)
            setValue('address_complement_delivery', '', true)
            setValue('address_reference_delivery', '', true)
            setValue('address_street_delivery', data.street, true)
            setValue('address_city_delivery', data.city, true)
            setValue('address_neighborhood_delivery', data.neighborhood, true)
            if (data.state && NormalizeBrazilianStates(data.state)) {
              setValue('address_state_delivery', NormalizeBrazilianStates(data.state), true)
            } else {
              this.setState({ disable_delivery_address_state: false })
            }
          }
          this.setState({
            invalid_address_zipcode: false,
          })
          if (this._isUniqueZipcode(data)) {
            this.setState({
              unique_zipcode: true,
            })
          } else {
            this.setState({
              unique_zipcode: false,
            })
          }
        })
        .catch(e => {
          console.log(e)
          if (this.state.same_address) {
            this._getFreight()
          }
          ;[
            'address_number',
            'address_complement',
            'address_reference',
            'address_street',
            'address_city',
            'address_neighborhood',
            'address_state',
          ].forEach(field => {
            setValue(field, '', true)
          })

          this.props.openModal(
            <ConfirmDialog
              text="Dados não encontrados para o cep informado."
              okLabel="Confirmar"
              ok={() => {
                this.props.closeModal()
              }}
            />,
          )

          this.setState({
            address_found: false,
            address_incomplete: true,
            unique_zipcode: false,
            invalid_address_zipcode: true,
          })
        })
    }
    this.props.closeLoader()
  }

  /**
   * Get full address by CEP number and fill the adresses fields
   **/
  _getDeliveryAddress(event, setValue, setAllValues) {
    this.props.openLoader()
    const value = event.target.value
    let cep = value.replace('-', '')

    if (cep.length === 8) {
      Cep(cep)
        .then(data => {
          this._getFreight(data)
          this.setState({
            delivery_address_found: true,
            delivery_address_incomplete: false,
          })
          setValue('address_number_delivery', '', true)
          setValue('address_complement_delivery', '', true)
          setValue('address_reference_delivery', '', true)
          setValue('address_street_delivery', data.street, true)
          setValue('address_city_delivery', data.city, true)
          setValue('address_neighborhood_delivery', data.neighborhood, true)
          if (data.state && NormalizeBrazilianStates(data.state)) {
            setValue('address_state_delivery', NormalizeBrazilianStates(data.state), true)
          } else {
            this.setState({ disable_delivery_address_state: false })
          }
          this.setState({
            delivery_invalid_address_zipcode: false,
          })
          if (this._isUniqueZipcode(data)) {
            this.setState({
              delivery_unique_zipcode: true,
            })
          } else {
            this.setState({
              delivery_unique_zipcode: false,
            })
          }
        })
        .catch(e => {
          console.log(e)
          this._getFreight()
            ;[
              'address_number_delivery',
              'address_complement_delivery',
              'address_reference_delivery',
              'address_street_delivery',
              'address_city_delivery',
              'address_neighborhood_delivery',
              'address_state_delivery',
            ].forEach(field => {
              setValue(field, '', true)
            })

          this.props.openModal(
            <ConfirmDialog
              text="Dados não encontrados para o cep informado."
              okLabel="Confirmar"
              ok={() => {
                this.props.closeModal()
              }}
            />,
          )

          this.setState({
            delivery_address_found: false,
            delivery_address_incomplete: true,
            delivery_unique_zipcode: false,
            delivery_invalid_address_zipcode: true,
          })
        })
    }
    this.props.closeLoader()
  }

  _isUniqueZipcode(address) {
    if (address.street === 'undefined' || address.street.length === 0) {
      return true
    }
    if (address.neighborhood === 'undefined' || address.neighborhood.length === 0) {
      return true
    }
    return false
  }

  isValidAddressNumber = number => ['number', 'string'].includes(typeof number) && String(number).length <= 10

  /**
   * Format fields and send data to action
   **/
  _handleRegister(values) {
    delete values['same_address_']
    delete values['confirm_password']
    delete values['confirm_email']

    // Rule in case the user does not click the checkbox.
    if (values.receive_offers === undefined) {
      values.receive_offers = 1
    }
    /*if (values.receive_surveys === undefined) {
      values.receive_surveys = 1
    }*/
    if (this.state.school_is_b2c) {
      values.b2c_terms_of_use_accepted_at = moment().format('YYYY-MM-DD HH:mm:ss')
      values.b2c_privacy_policy_accepted_at = moment().format('YYYY-MM-DD HH:mm:ss')
      delete values.terms_of_use_accepted_at
      delete values.privacy_policy_accepted_at
    } else {
      values.terms_of_use_accepted_at = moment().format('YYYY-MM-DD HH:mm:ss')
      values.privacy_policy_accepted_at = moment().format('YYYY-MM-DD HH:mm:ss')
      delete values.b2c_terms_of_use_accepted_at
      delete values.b2c_privacy_policy_accepted_at
    }

    if (values['ie_free'] === 1) {
      values['ie'] = 'ISENTO'
    }

    values.role_id = 1

    this.setState({
      showConfirmEmailModal: true,
      dataToRegister: values,
    })
  }

  _handleSubmit() {
    this.setState({
      showConfirmEmailModal: false,
    })
    this.props
      .submitRegisterForm(this.state.dataToRegister, true)
      .then(response => {
        window.ga('send', {
          hitType: 'event',
          eventCategory: 'compra',
          eventAction: 'click',
          eventLabel: 'cadastrou_4.1',
        })

        this.props.requestLogin(this.state.dataToRegister)
        // fluxo V2: retorna ao Resumo quando a navegação partiu do V2 (flag de sessão)
        if (sessionStorage.getItem('smd_v2_flow') === '1') {
          this.props.navigate('/v2/steps/resumo')
        } else {
          this.props.navigate('/steps/pagamento')
        }
      })
      .catch(error => {
        this.setState({
          errorModalOpen: true,
        })
      })
  }

  /**
   * Verify if the email is already taken
   **/
  _getUserByEmail(event) {
    const email = event.target.value
    return this.props.getUserByEmail({ email }).then(() => {
      return new Promise(resolve => {
        this.setState(
          {
            email,
          },
          () => setTimeout(() => resolve(email), 300),
        )
      })
    })
  }

  /**
   * Toggle CPF and CNPJ fields
   **/
  _toggleTypeField(name, setValue, fromUserAction = false) {
    // SMME26-26: o aviso do SEFAZ só faz sentido como reação ao clique do usuário no radio.
    // Chamadas programáticas (carga de dados) não devem abrir o modal.
    if (name === 'cnpj' && fromUserAction) this.setState({ ieModalOpen: true })
    this.setState({
      showingField: name,
      ieFetching: false,
      ieInactive: false,
      ieNotFound: false,
      ieExempt: false,
      ieError: false,
      lastCheckedCnpj: '',
    })
    setValue('cpf', '', true)
    setValue('cnpj', '', true)
    setValue('ie', '', true)
  }

  /**
   * Toggle CPF and CNPJ fields
   **/
  _toggleSameAddress(event, setValue, getValue) {
    // const same_address__ = event.target.value === 0 ? false : true
    const same_address__ = !this.state.same_address

    if (same_address__) {
      if (getValue('address_zipcode')) {
        this._getFreight({
          cep: getValue('address_zipcode'),
          city: getValue('address_city'),
          neighborhood: getValue('address_neighborhood'),
          state: getValue('address_state'),
          street: getValue('address_street'),
        })
      } else {
        this._getFreight()
      }
      setValue('address_zipcode_delivery', getValue('address_zipcode'), true)
      setValue('address_number_delivery', getValue('address_number'), true)
      setValue('address_complement_delivery', getValue('address_complement'), true)
      setValue('address_reference_delivery', getValue('address_reference'), true)
      setValue('address_street_delivery', getValue('address_street'), true)
      setValue('address_city_delivery', getValue('address_city'), true)
      setValue('address_neighborhood_delivery', getValue('address_neighborhood'), true)
      setValue('address_state_delivery', getValue('address_state'), true)
    } else {
      ;[
        'address_zipcode_delivery',
        'address_number_delivery',
        'address_complement_delivery',
        'address_reference_delivery',
        'address_street_delivery',
        'address_city_delivery',
        'address_neighborhood_delivery',
        'address_state_delivery',
      ].forEach(field => {
        setValue(field, '', true)
      })
      this._getFreight()
    }
    this.setState({
      same_address: same_address__,
      delivery_address_found: false,
      delivery_address_incomplete: true,
      delivery_unique_zipcode: false,
      delivery_invalid_address_zipcode: true,
    })
  }

  /**
   * All validations rules
   **/
  _validateForm(values) {
    const errorMsg = {
      empty: 'Campo obrigatório',
      invalidFullName: 'Digite seu nome completo',
      invalidChar: 'Há caracteres não permitidos',
      password: `A senha deve conter no mínimo 8 caracteres, pelo menos 1 letra maiúscula, pelo menos 1 letra minúscula, números de 0 a 9 e pelo menos um caractere especial (por exemplo '~ ! @ # $ % ^ & * ( ) _ + - = { } | \\ : " ; ' < > ? , . /)`,
      passwordLength: `A senha deve conter no mínimo 8 caracteres, pelo menos 1 letra maiúscula, pelo menos 1 letra minúscula, números de 0 a 9 e pelo menos um caractere especial (por exemplo '~ ! @ # $ % ^ & * ( ) _ + - = { } | \\ : " ; ' < > ? , . /)`,
      confirmPassword: 'As senhas devem ser iguais',
      validZipcode: 'Cep Inválido',
      notfoundZipcode: 'Cep Inválido',
      validEmail: 'Email inválido',
      confirmEmail: 'Os e-mails devem ser iguais',
      cpf: 'CPF inválido',
      cnpj: 'CNPJ inválido',
      ie: 'Inscrição Estadual inválida',
      addressNumberLength: 'O número deve conter no máximo 10 caracteres',
      addressComplementLength: 'O complemento deve conter no máximo 10 caracteres',
      addressReferenceLength: 'O Ponto de referência deve conter no máximo 40 caracteres',
      fullNameLength: 'O nome deve conter no máximo 40 caracteres',
    }
    const {
      email,
      confirm_email,
      password,
      confirm_password,
      full_name,
      phone,
      cpf,
      cnpj,
      ie,
      address_zipcode,
      address_street,
      address_number,
      address_neighborhood,
      address_city,
      address_state,
      address_complement,
      address_reference,
      address_zipcode_delivery,
      address_street_delivery,
      address_number_delivery,
      address_neighborhood_delivery,
      address_city_delivery,
      address_state_delivery,
      address_complement_delivery,
      address_reference_delivery,
      type,
      terms_of_use_accepted_at,
      privacy_policy_accepted_at,
    } = values

    let error = {
      email: !email ? errorMsg.empty : !regexEmail.test(email) ? errorMsg.validEmail : undefined,
      confirm_email: confirm_email !== email ? errorMsg.confirmEmail : undefined,
      password: !password ? errorMsg.empty : !regexPassword.test(password) ? errorMsg.passwordLength : undefined,
      confirm_password: confirm_password !== password ? errorMsg.confirmPassword : undefined,
      full_name:
              !full_name ? errorMsg.empty :
                !regexInvalidCharName.test(full_name) ? errorMsg.invalidChar :
                  full_name.length > maxLengthName ? errorMsg.fullNameLength :
                    !regexFullName.test(full_name) ? errorMsg.invalidFullName : undefined,
      phone: !phone ? errorMsg.empty : undefined,
      address_zipcode: !address_zipcode
        ? errorMsg.empty
        : !regexZipcodeFull.test(address_zipcode)
          ? errorMsg.validZipcode
          : undefined,
      address_street: !address_street ? errorMsg.empty : !regexInvalidCharTest.test(address_street) ? errorMsg.invalidChar : undefined,
      address_number: !address_number
        ? errorMsg.empty
        : !regexInvalidCharTest.test(address_number)
        ? errorMsg.invalidChar
        : address_number.toString().length > 10
        ? errorMsg.addressNumberLength
        : undefined,
      address_neighborhood: !address_neighborhood ? errorMsg.empty : !regexInvalidCharTest.test(address_neighborhood) ? errorMsg.invalidChar : undefined,
      address_city: !address_city ? errorMsg.empty : !regexInvalidCharTest.test(address_city) ? errorMsg.invalidChar : undefined,
      address_state: !address_state ? errorMsg.empty : !regexInvalidCharTest.test(address_state) ? errorMsg.invalidChar : undefined,
      address_complement:
        address_complement && !regexInvalidCharTest.test(address_complement) ? errorMsg.invalidChar : address_complement && address_complement.length > 10 ? errorMsg.addressComplementLength : undefined,
      address_reference:
        address_reference && !regexInvalidCharTest.test(address_reference) ? errorMsg.invalidChar : address_reference && address_reference.length > 40 ? errorMsg.addressReferenceLength : undefined,
      type: !type ? errorMsg.empty : undefined,
      terms_of_use_accepted_at: !terms_of_use_accepted_at ? errorMsg.empty : undefined,
      privacy_policy_accepted_at: !privacy_policy_accepted_at ? errorMsg.empty : undefined,
    }

    if (this.state.school_is_b2c) {
      error = {
        ...error,
        address_zipcode_delivery: !address_zipcode_delivery
          ? errorMsg.empty
          : !regexZipcodeFull.test(address_zipcode_delivery)
        ? errorMsg.validZipcode
        : undefined,

        address_street_delivery: !address_street_delivery ? errorMsg.empty : !regexInvalidCharTest.test(address_street_delivery) ? errorMsg.invalidChar : undefined,

        address_number_delivery: !address_number_delivery
          ? errorMsg.empty
          : !regexInvalidCharTest.test(address_number_delivery)
        ? errorMsg.invalidChar
        : address_number_delivery.length > 10
        ? errorMsg.addressNumberLength
        : undefined,

        address_neighborhood_delivery: !address_neighborhood_delivery ? errorMsg.empty : !regexInvalidCharTest.test(address_neighborhood_delivery) ? errorMsg.invalidChar : undefined,

        address_city_delivery: !address_city_delivery ? errorMsg.empty : !regexInvalidCharTest.test(address_city_delivery) ? errorMsg.invalidChar : undefined,

        address_state_delivery: !address_state_delivery ? errorMsg.empty : undefined,
        address_complement_delivery:
          address_complement_delivery && !regexInvalidCharTest.test(address_complement_delivery) ? errorMsg.invalidChar : address_complement_delivery && address_complement_delivery.length > 10
        ? errorMsg.addressComplementLength
        : undefined,
        address_reference_delivery: address_reference_delivery && !regexInvalidCharTest.test(address_reference_delivery) ? errorMsg.invalidChar : address_reference_delivery && address_reference_delivery.length > 40
        ? errorMsg.addressReferenceLength
        : undefined,
      }
    }

    if (this.state.showingField === 'cpf') {
      error.cpf = !CPF.isValid(cpf) ? 'CPF inválido' : !cpf ? errorMsg.empty : undefined
    }

    if (this.state.showingField === 'cnpj') {
      error.cnpj = !CNPJ.isValid(cnpj) ? 'CNPJ inválido' : !cnpj ? errorMsg.empty : undefined
      if (this.state.ieError) {
        // SMME26-26: consulta falhou → bloqueia sem texto. A orientação (e o botão de
        // reconsultar) já está no div register__ie__error; a mensagem genérica de campo
        // obrigatório aqui só confundiria, porque o usuário não tem como preencher na mão.
        error.ie = true
      } else if (!ie) {
        error.ie = 'Inscrição Estadual obrigatória'
      } else if (this.state.ieInactive && !this.state.ieExempt) {
        // SMME26-25 (RQ-007): IE inativa no Sintegra bloqueia o avanço. Usa `true` (não string)
        // só para bloquear o submit — a mensagem já é exibida pelo div register__ie__inactive,
        // evitando duplicar o texto com o FormError embutido do campo (InputText/FormInput).
        error.ie = true
      } else {
        error.ie = undefined
      }
    }

    if (!address_zipcode || !regexZipcodeFull.test(address_zipcode)) {
      this.setState({
        address_incomplete: true,
      })
    }

    if (!address_zipcode_delivery || !regexZipcodeFull.test(address_zipcode_delivery)) {
      this.setState({
        delivery_address_incomplete: true,
      })
    }

    if (phone && phone.length <= 9) {
      error.phone = 'Telefone inválido'
    }

    if (this.props.user.error) {
      error.email = this.props.user.error
    }

    console.log('error', error);

    return error
  }

  /**
   * SMME26-26: nova tentativa de consulta após falha. Zera `lastCheckedCnpj` para furar o
   * guard de "mesmo CNPJ" e reconsulta o valor que já está no campo.
   */
  _retryIeLookup() {
    // repassa os 3 args (o 3º é o `noTouch` do react-form) para não marcar o campo como
    // "touched" e disparar erro de validação antes de a consulta responder
    const setValue = (field, value, noTouch) => this.refs.Form.setValue(field, value, noTouch)
    this.setState({ lastCheckedCnpj: '' }, () => {
      this._fetchIeFromCnpj(this.refs.Form.getValue('cnpj') || '', setValue)
    })
  }

  /**
   * SMME26-26: a IE impede o avanço? Espelha exatamente as condições que o `_validateForm`
   * usa para setar `error.ie`. O react-form já barra o submit, mas com `error.ie = true` isso
   * acontece sem nenhum texto novo na tela — o botão habilitado passava a impressão de que
   * nada bloqueava. Desabilitar torna o bloqueio visível.
   */
  _isIeBlocking() {
    return this.state.ieFetching || this.state.ieError || (this.state.ieInactive && !this.state.ieExempt)
  }

  _fetchIeFromCnpj(cnpj, setValue) {
    // CNPJ alfanumérico (Nota Técnica RFB 2025.001): mantém letras A-Z.
    const cnpjDigits = cnpj.replace(/[^0-9A-Za-z]/g, '')
    // SMME26-26: os guards vêm ANTES de qualquer limpeza de estado. Antes o reset era a
    // primeira linha do método, então um blur em CNPJ inválido (ou repetido) apagava o
    // resultado da consulta anterior e fazia o checkbox "Isento" piscar/desaparecer.
    if (this.state.ieFetching) return
    if (!CNPJ.isValid(cnpjDigits)) return
    // SMME26-26: não reconsultar o mesmo CNPJ já avaliado com sucesso (a consulta ao Sintegra
    // é paga). Gravado só na resposta OK, então após falha um novo blur tenta de novo.
    if (cnpjDigits === this.state.lastCheckedCnpj) return
    // A partir daqui a consulta VAI acontecer: limpa o resultado anterior para que o checkbox
    // "Isento" fique oculto enquanto a requisição estiver em voo, em todos os cenários.
    this.setState({
      ieInactive: false,
      ieNotFound: false,
      ieExempt: false,
      ieError: false,
      ieFetching: true,
    })
    setValue('ie', '', true)
    setValue('ie_free', null, true)
    getIeByCnpj(cnpjDigits)
      .then(data => {
        // SMME26-26: falha na consulta não marca Isento nem libera o avanço — informa o
        // usuário e oferece o botão de reconsultar (ver render, register__ie__error).
        if (!data.success) {
          this.setState({ ieError: true })
          return
        }
        if (data.inscricao_estadual) {
          setValue('ie', data.inscricao_estadual, true)
          // SMME26-25 (RQ-007): IE inativa bloqueia o avanço (só quando o Sintegra sinaliza ie_ativa===false).
          this.setState({ ieInactive: data.ie_ativa === false, lastCheckedCnpj: cnpjDigits })
          return
        }
        // SMME26-25: CNPJ consultado com sucesso e SEM Inscrição Estadual (não-contribuinte) →
        // marca "Isento" automaticamente e bloqueia o campo IE (regra PO: "ou tem IE ou é Isento").
        setValue('ie', 'ISENTO', true)
        setValue('ie_free', 1, true)
        this.setState({ ieExempt: true, ieNotFound: true, lastCheckedCnpj: cnpjDigits })
      })
      .finally(() => {
        this.setState({ ieFetching: false })
      })
  }

  UNSAFE_componentWillMount() {
    let { specialDiscount } = this.props

    const has_special_discount = !_.isEmpty(specialDiscount) && !_.isEmpty(specialDiscount.special_discounts_document)

    if (has_special_discount) {
      setTimeout(() => {
        this.refs.Form.setValue('type', specialDiscount.special_discounts_doc_type)

        if (specialDiscount.special_discounts_doc_type === 'cpf') {
          this.refs.Form.setValue('cpf', specialDiscount.special_discounts_document)
          this.setState({
            showingField: 'cpf',
          })
        } else {
          this.refs.Form.setValue('cnpj', specialDiscount.special_discounts_document)

          this.setState({
            showingField: 'cnpj',
          })
        }
      }, 100)
    }
  }

  componentDidMount() {
    listVariables().then(data => {
      const newState = {
        variableTermUse: _.find(data, {
          key: this.state.school_is_b2c ? 'B2C_TERMS_OF_USE_FILE_PATH' : 'TERMS_OF_USE_FILE_PATH',
        }),
        variablePrivacyPolicy: _.find(data, {
          key: this.state.school_is_b2c ? 'B2C_PRIVACY_POLICY_FILE_PATH' : 'PRIVACY_POLICY_FILE_PATH',
        }),
      }

      this.setState(newState)
    })
  }

  _getFreight(data = null) {
    if (this.state.school_is_b2c) {
      this.props.openLoader()
      const __getVouchers = () => {
        var vouchers = []
        this.props.checkouts.forEach(voucher => {
          let voucher_products = []
          voucher.products.forEach(product => {
            if (product.active) {
              voucher_products.push({ voucher_product_id: product.id })
            }
          })
          vouchers.push({
            number: voucher.voucher,
            voucher_products: voucher_products,
          })
        })
        return vouchers
      }

      if (data) {
        let formated_data = {
          cep: data.cep.replace('-', ''),
          state: data.state,
          city: data.city,
          vouchers: __getVouchers(),
        }

        this.props.getFreight(formated_data)
      } else {
        this.props.resetFreight()
      }
      this.props.closeLoader()
    }
  }

  render() {
    let { title, subtitle, swapTo, specialDiscount, checkouts } = this.props
    const has_special_discount = !_.isEmpty(specialDiscount) && !_.isEmpty(specialDiscount.special_discounts_document)
    const first = _.first(checkouts)
    // eslint-disable-next-line
    this.state.school_is_b2c = first ? Boolean(first.school_is_b2c) : false
    return (
      <div className="register">
        {this.state.school_is_b2c && (
          <CepNotDeliverableModal
            show={this.state.showModalFreight}
            onClose={() => this.setState({ showModalFreight: false })}
          />
        )}
        {this.state.school_is_b2c && (
          <FreightUnavailableModal
            show={this.state.showModalFreightUnavailable}
            onClose={() => this.setState({ showModalFreightUnavailable: false })}
          />
        )}
        <Modal show={this.state.showConfirmEmailModal}>
          <Modal.Body>
            <div className="modalHeader">
              <span className="icon-alert" />
              <h1>Atenção</h1>
            </div>

            <div className="modalContent">
              <p className="text-center">
                Você está se registrando com: <strong>{this.state.email}</strong>
              </p>
              <p className="text-center yellow-text">Sim, esse é meu email.</p>
            </div>

            <div className="modalFooter" style={{ display: 'flex' }}>
              <button className="modal-close" onClick={() => this._handleSubmit()}>
                Confirmar
              </button>
              <button className="modal-support-btn" onClick={() => this.setState({ showConfirmEmailModal: false })}>
                Cancelar
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.school_is_b2c && !this.state.addressModalClose}>
          <Modal.Body>
            <div className="modalHeader">
              <span className="icon-alert" />
              <h1>Atenção</h1>
            </div>

            <div className="modalContent">
              <p>
                Por favor, certificar o preenchimento do "Endereço de Entrega", pois após a confirmação do pedido o
                endereço não poderá ser alterado.{' '}
              </p>
            </div>

            <div className="modalFooter">
              <button
                className="modal-close"
                onClick={() => {
                  this.setState({
                    addressModalClose: true,
                  })
                }}
              >
                Entendi
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <div className="register__header">
          <h3 className="register__title">{title}</h3>
          <h4 className="register__subtitle">{subtitle}</h4>
        </div>
        <Form
          ref="Form"
          validate={values => this._validateForm(values)}
          swapTo={swapTo}
          onSubmit={values => {
            if (this.state.school_is_b2c) {
              // SMME26-42 (opção C): CEP não atendido bloqueia; sem cálculo de frete pede "tente
              // novamente"; senão prossegue (timeout dos Correios volta com preço => prossegue).
              // TODO SMME26-42 (D3): pular a checagem p/ carrinho 100% digital (livro digital,
              // linha de negócio 8) — regra de detecção a confirmar com o time; nunca bloquear digital.
              if (this.props.has_delivery_restriction) {
                this.setState({ showModalFreight: true })
              } else if (this.props.calculated_freight === null) {
                this.setState({ showModalFreightUnavailable: true })
              } else {
                this._handleRegister(values)
              }
            } else {
              this._handleRegister(values)
            }
          }}
        >
          {({ submitForm, swapTo, setValue, getValue }) => {
            return (
              <form className="register__form" onSubmit={submitForm}>
                <div className="field">
                  <span className="field__label register__form__label">E-mail *</span>
                  <InputText
                    handleBlur={event => {
                      this._getUserByEmail(event)
                    }}
                    className="field__text"
                    field="email"
                  />
                </div>
                <div className="field">
                  <span className="field__label register__form__label">Confirme seu e-mail *</span>
                  <InputText blockPaste className="field__text" field="confirm_email" />
                </div>
                <div className="field">
                  <span className="field__label register__form__label">Senha *</span>
                  <InputPassword placeholder="" field="password" />
                </div>
                <div className="field">
                  <span className="field__label register__form__label">Confirme sua senha *</span>
                  <InputPassword
                    onPaste={event => {
                      event.preventDefault()
                      return false
                    }}
                    placeholder=""
                    field="confirm_password"
                  />
                </div>
                <div className="field">
                  <span className="field__label register__form__label">Nome Completo *</span>
                  <Text className="field__text" field="full_name" autoComplete="off" />
                </div>
                <div className="field">
                  <span className="field__label register__form__label">Telefone *</span>
                  <InputText
                    field="phone"
                    mask="(99) 9999-9999?"
                    formatChars={{
                      9: '[0-9]',
                      '?': '[0-9]',
                    }}
                    from={/\D/g}
                  />
                </div>
                <div className="address_fields">
                  <span className="field__divider">Endereço para faturamento da nota fiscal</span>
                  <label className="field">
                    <span className="field__label register__form__label">CEP *</span>
                    <div className="zipcodefield">
                      <InputText
                        handleBlur={e => {
                          this._getAddress(e, setValue)
                        }}
                        mask="99999-999"
                        field="address_zipcode"
                        className="field__text"
                      />
                      {this.state.invalid_address_zipcode ? (
                        <div className="FormError invalid-zip">Dados não encontrados para o cep informado</div>
                      ) : null}
                      <a
                        className="register__cep-link"
                        href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Não sabe o CEP?
                      </a>
                    </div>
                  </label>
                  <label className={`field`}>
                    <span className="field__label register__form__label">Logradouro *
                      <br />
                      <span style={{ fontSize: "12px" }}> Ex: Rua, Avenida, etc.</span>
                    </span>
                    <InputText
                      className="field__text"
                      field="address_street"
                      autoComplete="off"
                      handleChange={event => {
                        if (this.state.same_address) {
                          setValue('address_street_delivery', event.target.value, true)
                        }
                      }}
                    />
                  </label>
                  <label className={`field`}>
                    <span className="field__label register__form__label">Número *</span>
                    <InputText
                      className="field__text"
                      field="address_number"
                      maxLength="10"
                      handleChange={event => {
                        if (this.state.same_address) {
                          setValue('address_number_delivery', event.target.value, true)
                        }
                      }}
                    />
                  </label>
                  <div className={`field`}>
                    <span className="field__label register__form__label">Complemento</span>
                    <InputText
                      className="field__text"
                      field="address_complement"
                      maxLength="10"
                      handleChange={event => {
                        if (this.state.same_address) {
                          setValue('address_complement_delivery', event.target.value, true)
                        }
                      }}
                    />
                  </div>
                  
                  {this.state.school_is_b2c && <div
                    className={`field`}
                  >
                    <span className="field__label register__form__label">Ponto de referência</span>
                    <InputText
                      className="field__text"
                      field="address_reference"
                      maxLength="40"
                      handleChange={event => {
                        if (this.state.same_address) {
                          setValue('address_reference_delivery', event.target.value, true)
                        }
                      }}
                    />
                  </div>
                  }

                  <div className={`field`}>
                    <span className="field__label register__form__label">Bairro *</span>
                    <InputText
                      className="field__text"
                      field="address_neighborhood"
                      autoComplete="off"
                      handleChange={event => {
                        if (this.state.same_address) {
                          setValue('address_neighborhood_delivery', event.target.value, true)
                        }
                      }}
                    />
                  </div>
                  
                  <div className={`field ${this.state.disable_address_state ? 'disabled' : ''}`}>
                    <span className="field__label register__form__label">Estado *</span>
                    <SelectState
                      className="field__text"
                      field="address_state"
                      disabled={this.state.disable_address_state}
                      autoComplete="off"
                    />
                  </div>
                  <div className="field">
                    <span className="field__label register__form__label">Cidade *</span>
                    <Text className="field__text" field="address_city" />
                  </div>
                </div>

                <div className="field">
                  <span className="field__label register__form__label">CPF/CNPJ *</span>
                  <RadioGroup
                    field="type"
                    disabled={has_special_discount}
                    errorProps={this.hideDefaultError}
                    errorBefore={false}
                    className="field__radio"
                  >
                    <label className="field__radio__option">
                      <Radio
                        value="cpf"
                        disabled={has_special_discount}
                        onChange={() => {
                          this._toggleTypeField('cpf', setValue, true)
                          setValue('cnpj', '', true)
                          setValue('ie', null, true)
                          setValue('ie_free', null, true)
                        }}
                      />
                      <span className="field__radio__label">Pessoa física</span>
                    </label>
                    <label className="field__radio__option">
                      <Radio
                        value="cnpj"
                        disabled={has_special_discount}
                        onChange={() => {
                          this._toggleTypeField('cnpj', setValue, true)
                        }}
                      />
                      <span className="field__radio__label">Pessoa jurídica</span>
                    </label>
                  </RadioGroup>
                </div>
                {/* SMME26-26: os inputs seguem o valor do form (`type`), não o state
                    `showingField` — assim nenhum campo de documento aparece antes de o
                    usuário escolher "Pessoa física" ou "Pessoa jurídica". Cada um ganhou o
                    próprio rótulo ("CPF *" / "CNPJ *") na mesma estrutura do campo de
                    Inscrição Estadual — antes o input ficava solto abaixo dos radios. */}
                {getValue('type') === 'cpf' ? (
                  <div className="field register__field__cpf">
                    <span className="field__label register__form__label">CPF *</span>
                    <InputText field="cpf" mask="999.999.999-99" from={/\D/g} />
                  </div>
                ) : null}
                {getValue('type') === 'cnpj' ? (
                  <div className="field register__field__cnpj">
                    <span className="field__label register__form__label">CNPJ *</span>
                    <InputText
                      field="cnpj"
                      mask="**.***.***/****-99"
                      from={/[^0-9A-Za-z]/g}
                      handleBlur={e => this._fetchIeFromCnpj(e.target.value, setValue)}
                    />
                  </div>
                ) : null}
                {getValue('type') === 'cnpj' ? (
                  <React.Fragment>
                    <div className="field">
                      <span className="field__label register__form__label">
                        Inscrição Estadual *
                        {this.state.ieFetching && (
                          <span style={{ marginLeft: '8px', fontSize: '12px', color: '#888' }}>Buscando IE...</span>
                        )}
                      </span>
                      {/* SMME26-25: desabilitar (não ocultar) o campo IE ao marcar Isento */}
                      <InputText field="ie" mask="" from={/\D/g} disabled={this.state.ieExempt} className="register__ie__input" />
                    </div>
                    {this.state.ieInactive && !this.state.ieExempt && (
                      <div className="FormError invalid-zip register__ie__inactive">
                        Inscrição estadual inativa. Utilize outro CNPJ.
                      </div>
                    )}
                    {/* SMME26-25: CNPJ sem IE no Sintegra → "Isento" marcado automaticamente */}
                    {this.state.ieNotFound && (
                      <div className="register__ie__notfound">
                        Não localizamos Inscrição Estadual para este CNPJ. Marcamos &quot;Isento&quot; automaticamente.
                      </div>
                    )}
                    {/* SMME26-26: consulta indisponível — orienta o usuário a tentar de novo */}
                    {this.state.ieError && (
                      <div className="register__ie__error">
                        <p>
                          Não conseguimos consultar a Inscrição Estadual deste CNPJ agora. Normalmente é um problema
                          temporário no serviço de consulta.
                        </p>
                        <p>Confira se o CNPJ está correto e clique no botão abaixo para tentar de novo.</p>
                        <button
                          type="button"
                          className="register__ie__retry"
                          onClick={() => this._retryIeLookup()}
                          disabled={this.state.ieFetching}
                        >
                          Consultar novamente
                        </button>
                      </div>
                    )}
                    {/* SMME26-26: "Isento" é indicador read-only e só existe quando a consulta
                        retornou com sucesso E sem Inscrição Estadual. Fica oculto antes da
                        consulta, durante a requisição, com IE encontrada e em caso de falha. */}
                    {this.state.ieExempt && (
                      <div className="field field_ie_free">
                        <label>
                          <input type="checkbox" className="field__checkbox" checked disabled readOnly />
                          <span className="field__checkbox__label">Isento</span>
                        </label>
                      </div>
                    )}
                  </React.Fragment>
                ) : null}
                {this.state.school_is_b2c ? (
                  <div className="address_delivery_fields">
                    <span className="field__divider">Endereço de entrega</span>
                    <div className="warning">
                      <span>Atenção:</span> Estes dados não poderão ser alterados após a confirmação do pagamento.
                    </div>
                    <label className="same_address_label">
                      <InputCheckbox
                        onChange={event => this._toggleSameAddress(event, setValue, getValue)}
                        field="same_address_"
                        className="field__checkbox same_address__checkbox"
                        checked={getValue('same_address_') === undefined ? false : !getValue('same_address_')}
                      />
                      <span className="field__label_same_address_">
                        Os dados de entrega são os mesmos dados de faturamento.
                      </span>
                      <FormError field="same_address_" />
                    </label>
                    <label className={`field`}>
                      <span className="field__label register__form__label">CEP *</span>
                      <div className="zipcodefield">
                        <InputText
                          handleBlur={e => {
                            if (!this.state.same_address) {
                              this._getDeliveryAddress(e, setValue)
                            }
                          }}
                          disabled={this.state.same_address}
                          mask="99999-999"
                          field="address_zipcode_delivery"
                          className="field__text"
                        />
                        {this.state.invalid_address_zipcode ? (
                          <div className="FormError invalid-zip">Dados não encontrados para o cep informado</div>
                        ) : null}
                        <a
                          className="register__cep-link"
                          href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Não sabe o CEP?
                        </a>
                      </div>
                    </label>
                    <label
                      className={`field ${this.state.same_address ? 'disabled' : ''
                        }`}
                    >
                      <span className="field__label register__form__label">Logradouro
                        <br />
                        <span style={{ fontSize: "12px" }}> Ex: Rua, Avenida, etc.</span>
                      </span>
                      <Text
                        className="field__text"
                        field="address_street_delivery"
                        disabled={this.state.same_address}
                      />
                    </label>
                    <label
                      className={`field ${this.state.same_address ? 'disabled' : ''
                        }`}
                    >
                      <span className="field__label register__form__label">Número</span>
                      <Text
                        className="field__text"
                        field="address_number_delivery"
                        maxLength="10"
                        disabled={this.state.same_address}
                      />
                    </label>
                    <div
                      className={`field ${this.state.same_address ? 'disabled' : ''
                        }`}
                    >
                      <span className="field__label register__form__label">Complemento</span>
                      <Text
                        className="field__text"
                        field="address_complement_delivery"
                        maxLength="10"
                        disabled={this.state.same_address}
                      />
                    </div>
                    <div
                      className={`field ${this.state.same_address ? 'disabled' : ''
                        }`}
                    >
                      <span className="field__label register__form__label">Ponto de referência</span>
                      <Text
                        className="field__text"
                        field="address_reference_delivery"
                        maxLength="40"
                        disabled={this.state.same_address}
                      />
                    </div>
                    <div
                      className={`field ${this.state.same_address ? 'disabled' : ''
                        }`}
                    >
                      <span className="field__label register__form__label">Bairro</span>
                      <Text
                        className="field__text"
                        field="address_neighborhood_delivery"
                        disabled={this.state.same_address}
                      />
                    </div>
                    <div className={`field`}>
                      <span className="field__label register__form__label">Estado</span>
                      <SelectState
                        className="field__text"
                        field="address_state_delivery"
                        disabled={this.state.same_address}
                        autoComplete="off"
                      />
                    </div>
                    <div className={`field ${this.state.same_address ? 'disabled' : ''
                        }`}>
                      <span className="field__label register__form__label">Cidade</span>
                      <Text className="field__text" field="address_city_delivery" disabled={this.state.same_address} />
                    </div>
                  </div>
                ) : null}

                <div className="field__terms_of_use_accepted_at register__terms">
                  <label>
                    <Checkbox
                      errorProps={this.hideDefaultError}
                      field="terms_of_use_accepted_at"
                      className="field__checkbox terms__checkbox"
                    />
                    <span className="field__checkbox__label register__terms__label">
                      Li e aceito os{' '}
                      <a href="/termos-de-uso.html" target="_blank">
                        <strong>Termos de Uso</strong>
                        <span className="register__required">*</span>
                      </a>
                    </span>
                    <FormError field="terms_of_use_accepted_at" />
                  </label>
                </div>
                <div className="field__privacy_policy_accepted_at register__terms">
                  <label>
                    <Checkbox
                      errorProps={this.hideDefaultError}
                      field="privacy_policy_accepted_at"
                      className="field__checkbox terms__checkbox"
                    />
                    <span className="field__checkbox__label register__terms__label">
                      Li e aceito as{' '}
                      <a href="/politica-de-privacidade.html" target="_blank">
                        <strong>Políticas de Privacidade</strong>
                        <span className="register__required">*</span>
                      </a>
                    </span>
                    <FormError field="privacy_policy_accepted_at" />
                  </label>
                </div>

                {/*<div className='field__receive_surveys register__terms'>
                  <label>
                    <InputCheckbox
                      field='receive_surveys'
                      className='field__checkbox terms__checkbox'
                      checked={getValue('receive_surveys') === undefined ? false : !getValue('receive_surveys')}
                    />
                    <span className='field__checkbox__label register__terms__label'>
                      Não desejo participar de pesquisas de satisfação de produtos e serviços do Grupo SM
                    </span>
                  </label>
                </div>*/}

                <div className="field__receive_offers register__terms">
                  <label>
                    <InputCheckbox
                      field="receive_offers"
                      className="field__checkbox terms__checkbox"
                      checked={getValue('receive_offers') ? true : false}
                    />
                    <span className="field__checkbox__label register__terms__label">
                      Não desejo receber comunicações comerciais do Grupo SM
                    </span>
                  </label>
                </div>

                <Text type="hidden" field="role" autoComplete="off" />

                <div className="register__buttons">
                  <button
                    className="register__button button__normal--cancel"
                    type="button"
                    onClick={() => {
                      swapTo(0)
                    }}
                  >
                    Cancelar
                  </button>
                  {/* SMME26-26: bloquear o envio enquanto a IE está sendo consultada no Sintegra */}
                  <button className="register__button button__normal" type="submit" disabled={this._isIeBlocking()}>
                    Cadastrar
                  </button>
                </div>
              </form>
            )
          }}
        </Form>

        <Modal show={this.state.ieModalOpen}>
          <Modal.Body>
            <div className="modalHeader">
              <span className="icon-alert" />
              <h1>Aviso</h1>
            </div>

            <div className="modalContent">
              <p>
                Caso você possua a <strong>Inscrição Estadual Ativa</strong> e opte por não
                preencher este campo, a sua nota fiscal <strong>NÃO</strong> será aprovada pelo <strong>SEFAZ</strong>
              </p>
            </div>

            <div className="modalFooter">
              <button
                className="modal-close"
                onClick={() => {
                  this.setState({
                    ieModalOpen: false,
                  })
                }}
              >
                Entendi
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={this.state.errorModalOpen}>
          <Modal.Body>
            <div className="modalHeader">
              <span className="icon-alert" />
              <h1>Erro</h1>
            </div>

            <div className="modalContent">
              <p>Ocorreu um erro ao realizar o seu cadastro. Tente novamente mais tarde!</p>
            </div>

            <div className="modalFooter">
              <button
                className="modal-close"
                onClick={() => {
                  this.setState({
                    errorModalOpen: false,
                  })
                }}
              >
                Entendi
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  user: state.user,
  checkouts: state.checkout,
  specialDiscount: state.specialDiscount,
  calculated_freight: state.freight.calculated_freight,
  has_delivery_restriction: state.freight.has_delivery_restriction,
  freight_redux_requests: state.freight.freight_redux_requests,
})

const mapDispatchToProps = dispatch => ({
  openLoader: () => dispatch(openLoader()),
  closeLoader: () => dispatch(closeLoader()),
  closeModal: () => dispatch(closeModal()),
  openModal: component => dispatch(openModal(component)),
  getFreight: data => dispatch(getFreight(data)),
  resetFreight: () => dispatch(resetFreight()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterForm))

